import { Component, Input, ElementRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BbTableService, TableColumn, TableSort } from '../../../services/bb-table.service';

@Component({
	selector: 'bb-table-header-cell',
	templateUrl: './bb-table-header-cell.component.html',
	styleUrls: ['./bb-table-header-cell.component.scss']
})

export class BbTableHeaderCellComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() property: string;
	@Input() optional: boolean | string = false;
	@Input() hideSorting = false;
	visible = false;

	el: HTMLElement;

	rowsSortedSubscription: Subscription;
	columnsChangedSubscription: Subscription;

	sortDirection: string = null;

	constructor(private bbTableService: BbTableService, private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {

		if (this.property) {

			this.bbTableService.registerColumn({
				property: this.property,
				label: this.determineLabel(this.el), // this might be empty at this point, we'll update the labels when they appear/change
				optional: (this.optional !== false)
			} as TableColumn);

		} else {
			this.visible = true;
		}

		this.rowsSortedSubscription = this.bbTableService.rowsSortedObservable.subscribe((sorting: TableSort) => {

			if (!this.property) {
				// not relevant for us
				return;
			}

			if (sorting.sortProperty === this.property) {
				this.sortDirection = sorting.sortDirection;
			} else {
				this.sortDirection = null;
			}
		});

		// initially
		this.updateVisibility(this.bbTableService.columns);

		// when visibility changes...
		this.columnsChangedSubscription = this.bbTableService.columnsChangedObservable
			.subscribe((columns: TableColumn[]) => {
				this.updateVisibility(columns);
			});

		if (!this.visible) {
			this.el.setAttribute('hidden', 'true');
		}
	}

	ngAfterViewInit() {

		if (!this.property) {
			// not relevant for us
			return;
		}

		const label = this.determineLabel(this.el);

		setTimeout(() => {
			this.bbTableService.updateLabelForColumn(this.property, label);
		});
	}

	determineLabel(el: HTMLElement): string {

		// we grab the text content of our element ourselves (recursively)
		// since innerText doesn't work on hidden elements

		let label = '';

		if (el.nodeName === '#text') {
			label += el.nodeValue.trim();
		}

		if (el.childNodes.length) {
			for (let i = 0; i < el.childNodes.length; i++) {
				label += this.determineLabel(el.childNodes[i] as HTMLElement);
			}
		}

		return label;
	}

	updateVisibility(columns: TableColumn[]) {
		let visible = !this.property;

		columns.forEach((column: TableColumn) => {
			if (column.property === this.property) {
				visible = column.visible;
			}
		});

		this.visible = visible;

		if (!this.visible) {
			this.el.setAttribute('hidden', 'true');
		} else {
			this.el.removeAttribute('hidden');
		}
	}

	ngOnDestroy() {
		this.rowsSortedSubscription.unsubscribe();
		this.columnsChangedSubscription.unsubscribe();
	}

	clicked() {
		if (!this.hideSorting && this.property) {
			this.bbTableService.updateSort(this.property);
		}
	}
}
